<template>
  <div>
    <Head :title="`${form.first_name} ${form.last_name}`" />
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link href="/users">Users</Link></li>
        <li class="breadcrumb-item active" aria-current="page">{{ form.first_name }} {{ form.last_name }}</li>
      </ol>
    </nav>
    <h1>
      {{ form.first_name }} {{ form.last_name }}
    </h1>

    <trashed-message v-if="user.deleted_at" class="mb-6" @restore="restore"> This user has been deleted. </trashed-message>
    <div class="content-box">
      <form @submit.prevent="update">
        <div class="mb-3">
          <text-input v-model="form.first_name" :error="form.errors.first_name" label="First name" />

          <text-input v-model="form.last_name" :error="form.errors.last_name" label="Last name" />

          <text-input v-model="form.email" :error="form.errors.email" label="Email" />

          <text-input v-model="form.password" :error="form.errors.password" type="password" autocomplete="new-password" label="Password" />

          <select-input v-if="auth.user.role_admin" v-model="form.role" :error="form.errors.role" label="Role">
            <option value="1">Admin</option>
            <option value="2">Agency Owner</option>
            <option value="0">Agent</option>
          </select-input>

          <select-input v-if="auth.user.role_admin" v-model="form.agencies_id" :error="form.errors.agencies_id" label="Agency">
            <option>Select Agency</option>
            <option v-for="agency in agencies" :key="agency.id" :value="agency.id">{{ agency.name }}</option>
          </select-input>
        </div>
        <div class="actions-toolbar d-flex justify-content-between">
          <button v-if="!user.deleted_at" class="btn btn-outline-danger" tabindex="-1" type="button" @click="destroy">Delete User</button>
          <loading-button :loading="form.processing" class="btn btn-primary" type="submit">Update User</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    user: Object,
    agencies: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        email: this.user.email,
        password: '',
        role: this.user.role,
        agencies_id: this.user.agencies_id
      }),
    }
  },
  computed: {
    auth() {
      return this.$page.props.auth
    }
  },
  methods: {
    update() {
      this.form.post(`/users/${this.user.id}`, {
        onSuccess: () => this.form.reset('password', 'photo'),
      })
    },
    destroy() {
      if (confirm('Are you sure you want to delete this user?')) {
        this.$inertia.delete(`/users/${this.user.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this user?')) {
        this.$inertia.put(`/users/${this.user.id}/restore`)
      }
    },
  },
}
</script>
